// extracted by mini-css-extract-plugin
module.exports = {"starRating":"StarRating-starRating-3MkFK","backStar":"StarRating-backStar-oeYbY","frontStar":"StarRating-frontStar-25trz"};